import { useCallback, useEffect, useRef, useState } from 'react';

/** 간단한 조회 훅. deps가 바뀌거나 reload()를 부르면 다시 읽는다. 늦게 도착한 이전 응답은 버린다. */
export function useAsync<T>(load: () => Promise<T>, deps: unknown[]) {
  const [state, setState] = useState<{ data: T | null; error: Error | null; loading: boolean }>({ data: null, error: null, loading: true });
  const [tick, setTick] = useState(0);
  const seq = useRef(0);
  useEffect(() => {
    const current = ++seq.current;
    setState((s) => ({ ...s, loading: true, error: null }));
    load().then(
      (data) => current === seq.current && setState({ data, error: null, loading: false }),
      (error: Error) => current === seq.current && setState((s) => ({ data: s.data, error, loading: false }))
    );
    return () => { seq.current += 1; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, tick]);
  const reload = useCallback(() => setTick((t) => t + 1), []);
  return { ...state, reload };
}
